import { useSale } from '../../../../hooks/sale/useSale';

import POSSummaryTotalRow from './POSSummaryTotalRow';

import { formatCurrency } from '../../../../utils/formatCurrency';

const POSSummaryTotals = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form } = useSale();

  // =====================================================
  // 🔹 Totals
  // =====================================================
  const totals = form?.totalsView?.items || [];

  if (!totals.length) return null;

  const totalItem =
    totals.find((item) => item.isTotal) || totals[totals.length - 1];

  const detailItems = totals.filter((item) => item.key !== totalItem?.key);

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
      mt-5
    "
    >
      {/* ===================================================== */}
      {/* 🔹 Detail Totals */}
      {/* ===================================================== */}
      <div className="space-y-3">
        {detailItems.map((item) => (
          <POSSummaryTotalRow key={item.key} item={item} />
        ))}
      </div>

      {/* ===================================================== */}
      {/* 🔹 Final Total */}
      {/* ===================================================== */}
      <div
        className="
        mt-5

        flex
        items-center
        justify-between

        border-t
        border-stroke

        pt-4

        dark:border-strokedark
      "
      >
        <span
          className="
          text-lg
          font-semibold

          text-black

          dark:text-white
        "
        >
          Total a pagar
        </span>

        <span
          className="
          text-3xl
          font-bold

          tracking-tight

          text-primary
        "
        >
          ${formatCurrency(totalItem?.value)}
        </span>
      </div>
    </div>
  );
};

export default POSSummaryTotals;
